import { TextField } from '@material-ui/core';
import styled, { css } from 'styled-components';
import { StyledIconButton, StyledButton, GutterCSS, PaddingCSS } from 'styles/common';

export const StyledIconButton1 = styled(StyledIconButton)`
  width: 28px !important;
  height: 28px !important;
  svg {
    height: 0.8em;
    width: 0.8em;
  }
  ${(props) =>
    props.disabled &&
    css`
      span {
        opacity: 0.4;
      }
    `}
`;

export const StyledTextField = styled(TextField)`
  input {
    font-size: 0.875rem;
    padding: 8px 0;
    ${PaddingCSS};
  }
  fieldset {
    border: none;
  }
  ${GutterCSS}
`;

export const StyledButton1 = styled(StyledButton)`
  p {
    font-size: 0.875rem;
  }
  ${(props) =>
    props.disabled &&
    css`
      span {
        opacity: 0.4;
      }
    `}
`;

export const SkeletonContainer = styled.div`
  padding: 1.5rem 1.5rem;
`;
